import React, { useEffect } from "react";
import { Input } from "@my-scoot/component-library-legacy";
import { getUserCurrencySymbol } from "utils/AuthUtil";
import useDebounce from "hooks/useDebounce";
import { useWalletStore } from "features/Account/modules/Wallets/store/WalletStore";
import {
  AMOUNT_FIELD_PLACEHOLDER,
  WALLET_SETTING_KEYS,
} from "features/Account/modules/Wallets/constants/Wallets.constants";
import { useWalletSettings } from "../../utils/useWalletSettings";
import { validateAmountField } from "features/Account/modules/Wallets/utils/Wallets.utils";
import { useWallets } from "features/Account/modules/Wallets/utils/useWallets";

export const MinimumBalanceField = ({ isDebounce }) => {
  const currencySymbol = getUserCurrencySymbol();

  const minBalanceValue = useWalletStore((state) => state.minBalanceValue);
  const setMinBalanceValue = useWalletStore(
    (state) => state.setMinBalanceValue
  );
  const { handleSettingsSectionValueChange } = useWalletSettings();
  const { refreshWalletBalance } = useWallets({
    isFetchWalletBalanceEnabled: true,
  });
  const {
    setValue: setMinimumBalance,
    debouncedValue: debouncedMinimumBalanceValue,
  } = useDebounce({
    inititalValue: minBalanceValue,
    delay: 1000,
  });

  const handleInputChange = (val) => {
    if (!validateAmountField(val)) {
      return;
    }
    setMinBalanceValue(val);
    setMinimumBalance(val);
  };

  useEffect(() => {
    if (debouncedMinimumBalanceValue && isDebounce) {
      handleSettingsSectionValueChange(WALLET_SETTING_KEYS.WALLET_CONFIG, {
        [WALLET_SETTING_KEYS.MIN_BALANCE_LIMIT]: debouncedMinimumBalanceValue,
      });
      refreshWalletBalance();
    }
  }, [debouncedMinimumBalanceValue]);

  return (
    <div className="tw-relative tw-items-center">
      <Input
        value={minBalanceValue}
        name="min_balance_limit"
        size="small"
        type="number"
        inputElementClassName="!tw-pl-10"
        placeholder={AMOUNT_FIELD_PLACEHOLDER}
        onChange={({ target: { value } }) => handleInputChange(value)}
      />
      <span className="tw-absolute tw-left-3 tw-top-[8px] tw-text-gray-400 tw-pointer-events-none">
        {currencySymbol}
      </span>
    </div>
  );
};
